export default [
    {
        path: '/roles',
        name: 'roles',
        component: () => import(/* webpackChunkName: "Roles" */ '@/views/roles/Index.vue'),
        meta: {
            title: 'Rollen & Rechten',
            requiresAuth: true,
        }
    },
    {
        path: '/roles/create',
        name: 'addRole',
        component: () => import(/* webpackChunkName: "RolesCreate" */ '@/views/roles/Create.vue'),
        meta: {
            title: 'Rol toevoegen',
            requiresAuth: true,
        }
    },
    {
        path: '/roles/edit/:id',
        name: 'editRole',
        component: () => import(/* webpackChunkName: "RolesEdit" */ '@/views/roles/Edit.vue'),
        meta: {
            title: 'Rol bewerken',
            requiresAuth: true,
        }
    }
];